import Popups from '../Popups'
import React from 'react'
import Settings from '.'

const SettingsPage: React.FC = () => {
  return (
    <div className='account'>
      <Popups />
      <div className='account__main account__page'>
        <Settings />
      </div>
    </div>
  )
}

export default SettingsPage